import { useEffect, useState } from "react";

const host_email = "hogast@hogast.hr";

export default function usePostEMail() {
  const [respStatus, setRespStatus] = useState(0);

  useEffect(() => {
    if (respStatus === 2 || respStatus === -1) {
      setTimeout(() => {
        setRespStatus(0);
      }, [2500]);
    }
  }, [respStatus]);

  const sendEMail = async (data = {}) => {
    data = { ...data, host_email };

    try {
      setRespStatus(1);

      const response = await fetch(
        `https://hogast.hr/wp/wp-json/contact/v1/send/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ ...data }),
          mode: "cors",
        }
      );


      if (response.ok) {
        setRespStatus(2);
      } else {
        setRespStatus(-1);
      }
    } catch (err) {
      setRespStatus(-1);

      console.log("Loading error: ", err.message);
    }
  };

  return [respStatus, sendEMail];
}
